import React from 'react';
import { useTranslation } from 'react-i18next';

type StepStatus = 'done' | 'current' | 'pending';
const statuses: StepStatus[] = ['done', 'done', 'current', 'pending'];
const statusIcon: Record<StepStatus, string> = { done: '✓', current: '●', pending: '○' };

const QualitySlide: React.FC = () => {
  const { t } = useTranslation();
  const m = t('demoTour.mockups.quality', { returnObjects: true }) as any;

  return (
    <div className="dt-mockup-quality">
      <div className="dt-quality-toolbar">
        <span className="dt-quality-toolbar-title">{m.toolbarTitle}</span>
        <span className="dt-quality-toolbar-badge">{m.toolbarBadge}</span>
      </div>
      <div className="dt-kpi-grid-3">
        {m.kpis.map((kpi: any) => (
          <div key={kpi.label} className="dt-kpi-card">
            <div className="dt-kpi-value" style={{ color: kpi.color }}>{kpi.value}</div>
            <div className="dt-kpi-label">{kpi.label}</div>
          </div>
        ))}
      </div>
      <div className="dt-pdca-steps">
        {m.steps.map((step: any, i: number) => {
          const status = statuses[i];
          return (
            <div key={i} className={`dt-coaching-step dt-coaching-step--${status}`}>
              <div className="dt-coaching-step-icon">{statusIcon[status]}</div>
              <div className="dt-coaching-step-content">
                <div className="dt-coaching-step-label">{step.label}</div>
                <div className="dt-coaching-step-date">{statusIcon[status]} {step.statusLabel}</div>
              </div>
              {i < m.steps.length - 1 && <div className="dt-coaching-step-line" />}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default QualitySlide;
